import React from "react";
import { StyleSheet } from "react-native";

import {
  Block,
  type IconNames,
  SvgIcon,
  Touchable,
  Typography,
  palette,
  spacing,
} from "@stepapp/ui";

type Props = {
  onPress: () => void;
  label: string;
  icon?: IconNames;
  size?: number;
};

const NavigationButton = ({ size, icon, onPress, label }: Props) => (
  <Touchable onPress={onPress} style={styles.navigationButton}>
    {!!icon && (
      <Block style={styles.iconContainer}>
        <SvgIcon color={palette.font.placeholder} name={icon} size={size || 28} />
      </Block>
    )}
    <Typography variant="sectionTitle">{label}</Typography>
  </Touchable>
);

export default React.memo(NavigationButton);

const styles = StyleSheet.create({
  iconContainer: {
    width: spacing.unit * 6,
  },
  navigationButton: {
    alignItems: "center",
    flexDirection: "row",
    paddingLeft: spacing.unit * 1,
    paddingRight: spacing.unit * 6,
    paddingVertical: spacing.unit * 2,
    width: "100%",
  },
});
